export default __webpack_public_path__ + "static/media/mist_grass_pollen.28787976.png";